import React from "react";

/**
 * Extract a YouTube video ID from any common URL form:
 *  - https://www.youtube.com/watch?v=XXXX
 *  - https://youtu.be/XXXX
 *  - https://youtube.com/shorts/XXXX
 *  - https://www.youtube.com/embed/XXXX
 */
export const parseYouTubeId = (url) => {
  if (!url || typeof url !== "string") return null;
  const s = url.trim();
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtube\.com\/embed\/|youtu\.be\/|youtube\.com\/shorts\/|youtube\.com\/v\/)([A-Za-z0-9_-]{6,20})/,
  ];
  for (const p of patterns) {
    const m = s.match(p);
    if (m && m[1]) return m[1];
  }
  return null;
};

export const isYouTubeShort = (url) => /youtube\.com\/shorts\//i.test(url || "");

const YouTubeEmbed = ({
  url,
  className = "",
  aspectClass = "aspect-video",
  title = "YouTube video",
  testId,
  autoplay = false,
}) => {
  const id = parseYouTubeId(url);
  if (!id) return null;
  const src = `https://www.youtube.com/embed/${id}?rel=0&modestbranding=1${
    autoplay ? "&autoplay=1&mute=1" : ""
  }`;
  return (
    <div
      className={`overflow-hidden rounded-2xl border border-line bg-black ${aspectClass} ${className}`}
      data-testid={testId}
    >
      <iframe
        src={src}
        title={title}
        loading="lazy"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        className="h-full w-full"
      />
    </div>
  );
};

export default YouTubeEmbed;
